export enum NewsStatuses {
  NEWS = 'news',
  EVENT = 'event',
  NOTIFICATION = 'notification'
}

export const NewsStatusesTranslate: Record<string, string> = {
  [NewsStatuses.NEWS]: 'Новость',
  [NewsStatuses.EVENT]: 'Мероприятие',
};

export const news_statuses = Object.keys(
  NewsStatusesTranslate,
).map(
  (f: string) => ({ text: NewsStatusesTranslate[f], value: f }),
);
